var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-container"},[_c('Pheader'),_c('router-view'),_c('Pfooter'),_c('tool')],1)}
var staticRenderFns = []

export { render, staticRenderFns }